import { ApplicationState } from '@/store';
import React, { SyntheticEvent } from 'react';
import { useSelector } from 'react-redux';

type ProgressBarMode = 'NORMAL' | 'THIN';

interface Props {
    mode?: ProgressBarMode;
    progress: number;
    onCancelHandler: (event: SyntheticEvent, onUploadCancelHandler?: CallableFunction, onRemoveHandler?: CallableFunction) => void;
}

const ProgressUpload: React.FC<Props> = ({ mode = 'NORMAL', progress, onCancelHandler }: Props) => {
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);

    const isThinMode = mode === 'THIN';

    return (
        <div className={`upload-progress-container d-flex flex-column ${!isThinMode ? 'ml-3 w-75' : ''}`}>
            <div className="progress-view">
                <div className={`progress ${isThinMode ? 'progress-thin' : ''}`}>
                    <div
                        aria-valuemax={100}
                        aria-valuemin={0}
                        aria-valuenow={0}
                        className={`progress-bar ${isThinMode ? 'progress-bar-thin' : ''}`}
                        style={{ width: `${progress}%` }}
                    />
                </div>
                {!isThinMode && <span>{progress} %</span>}
            </div>
            <span
                className={`cancel-upload-text ${isThinMode ? 'thin-text' : ''}`}
                onClick={onCancelHandler}
                onKeyDown={() => {}}
                role="button"
                tabIndex={0}
            >
                {strings.CANCEL}
            </span>
        </div>
    );
};

export default ProgressUpload;
